import React from 'react';
import PropTypes from 'prop-types';
// common
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// scss
import './../../../common/CommonList/Table.scss';

const columns = [
	{
		key: null,
		label: 'S.No'
	},
	{
		key : 'firstname',
		secKey: 'lastname',
		label : 'Name'
	},
	{
		key: 'email',
		label: 'E-Mail'
	}
];

const SalesExecutiveTable = ({ salesexecutiveList, manageSalesExecutive  }) => {		
	if (salesexecutiveList && salesexecutiveList.length > 0) {
		return (
			<table className="table SalesExecutiveTable">			
				<thead>
					<tr>
						{columns.map((item, i) => (
							<th key={i} id={item.key}>{item.label}</th>
						))}
						<th></th>
					</tr>
				</thead>
				<tbody>
					{salesexecutiveList.map((item, i) => (		
					    <tr key={i}>
							{columns.map((column, j) => {
								if (!column.key) {
									return <td key={j}>{i + 1}</td>;
								}
								return <td key={j}>{item[column.key]} {column.secKey && item[column.secKey]}</td>;
							})}
							<td className="text-right">
								<CustomButton
									iconOnly
									iconName='edit'														
									onClick={() => manageSalesExecutive(true, 'edit', item.id)}
								/>
								<CustomButton
									iconOnly
									iconName='delete'									
									onClick={() => manageSalesExecutive(true, 'delete', item.id)}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		);
	}
	return (<Loader />);
}

SalesExecutiveTable.propTypes = {
	salesexecutiveList: PropTypes.instanceOf(Array),
	manageSalesExecutive: PropTypes.func
};

SalesExecutiveTable.defaultProps = {
	salesexecutiveList: [],
	manageSalesExecutive: () => {}
};

export default SalesExecutiveTable;



// WEBPACK FOOTER //
// ./components/SalesExecutive/SalesExecutiveList/SalesExecutiveTable.js